import { useMutation } from '@tanstack/react-query';
import { signinPrivate } from '@/services/auth/auth-actions';

export function useSigninPrivateMutation() {
  return useMutation({ mutationFn: signinPrivate });
}
